// import Picker from 'pickerjs/dist/picker';
// import flatpickr from "flatpickr";
import moment from "moment";
// import { array } from "yargs";
export default {
  init() {
    // var locationSelected = sessionStorage.getItem('user_delivery');
    // var methods = document.querySelectorAll('.woocommerce-shipping-methods li');
    // var checkout = document.querySelector('form.woocommerce-checkout');
    var empresa = document.querySelector('#billing_company_field input');
    var pais = document.querySelector('#billing_country_field select');
    var direccion = document.querySelector('#billing_address_1_field input');
    var direccion_extra = document.querySelector('#billing_address_2_field input');
    var codigo_postal = document.querySelector('#billing_postcode_field input');
    var ciudad =  document.querySelector('#billing_city_field input');
    var provincia = document.querySelector('#billing_state_field select');
    var numero = document.querySelector('#billing_address_number_field input');
    var piso = document.querySelector('#billing_address_door_field input');
    const ajaxurl = window.ajaxurl;

    var addressSaved = JSON.parse(localStorage.getItem('user_location'));

    

    // var setShipping = () => {
    //   if (locationSelected !== 'delivery') {
    //     methods.forEach(method => {
    //       var input = method.querySelector('input');
    //       if (input.value.includes('pickup')) {
    //         method.style.display = 'block';
    //       }
    //     });
    //   }
    // }

    // checkout.addEventListener('change', function() {
    //   console.log('hello');
    // });
    switch (window.getCookie('user_type')) {
      case 'pickup':
        empresa.value = 'Método de entrega: Recogida en tienda';    
        break;
    
      case 'delivery':
        empresa.value = 'Método de entrega: Delivery';
        break;

      case 'local':
        empresa.value = 'Método de entrega: Pedido en el local';
        break;
    }
    

    if(window.getCookie('user_type') == 'delivery') {
      var postCode = addressSaved.context[0].text;
      var city = addressSaved.context[2].text;

      pais.value =  'ES';
      // direccion.value = addressSaved.place_name.split(',')[0];
      direccion.value = addressSaved.text;
      direccion_extra.value = '';
      codigo_postal.value = postCode;
      ciudad.value = city;
      provincia.value = 'B';
      numero.value = localStorage.getItem('addressNumber');

    } else {
      pais.value = 'ES';
      direccion.value = 'Plaça del Diamant,';
      direccion_extra.value = '';
      codigo_postal.value = '08012';
      ciudad.value = 'Barcelona';
      provincia.value = 'B';
      numero.value = '5';
      piso.value = 'local';
    }
    
    setTimeout(() => {
      var moneyChange = document.querySelector('.extra-info input');

      moneyChange.addEventListener('input', function () {
        if (moneyChange.value > 0 || moneyChange.value !== "") {
          document.querySelector('#order_comments').value = 'Se necesita cambio de ' + moneyChange.value + '€';
        } else {
          document.querySelector('#order_comments').value = '';
        }
      })
    }, 1000);

    var input = document.querySelector('.picker select');
    var selectWrapper = document.querySelector('.hourSelection');

    function setHoursRange(hours, limit, today) {
      let items = [];
      // var today = moment().day();
      var dayName = moment().format('dddd');

      var todaySchedule = window.schedule[dayName];

      if(localStorage.getItem('user_delivery') !== 'delivery') {

        if (Object.keys(todaySchedule).length > 2) {

          var openMorning = todaySchedule[0].split(':');
          var closeMorning = todaySchedule[1].split(':');
          var openAfternoon = todaySchedule[2].split(':');
          var closeAfternoon = todaySchedule[3].split(':');

          if (moment().isBetween(moment().hour(openMorning[0]).minute(openMorning[1]).second(openMorning[2]) , moment().hour(closeMorning[0]).minute(closeMorning[1]).second(closeMorning[2])) && today) {
            items.push('Lo antes posible');
          } else if (moment().isBetween(moment().hour(openAfternoon[0]).minute(openAfternoon[1]).second(openAfternoon[2]), moment().hour(closeAfternoon[0]).minute(closeAfternoon[1]).second(closeAfternoon[2])) && today) {
            items.push('Lo antes posible');
          }

        } else {
          var _openMorning = todaySchedule[0].split(':');
          var _closeMorning = todaySchedule[1].split(':');

          if (moment().isBetween(moment().hour(_openMorning[0]).minute(_openMorning[1]).second(_openMorning[2]), moment().hour(_closeMorning[0]).minute(_closeMorning[1]).second(_closeMorning[2])) && today) {
            items.push('Lo antes posible');
            
          }
        }
        
      }

      for (var hour = hours[0]; hour < hours[1]; hour++) {
        // items.push([hour, 0], [hour, 30]);
        if (limit !== hour) {
          if (moment().hour() == hour && moment().minutes() > 29 && today) {
            items.push(hour + ':30 - ' + (Number(hour) + 1).toString() + ':00');
          } else {
            items.push(hour + ':30 - ' + (Number(hour) + 1).toString() + ':00');
            items.push((Number(hour) + 1).toString() + ':00 - ' + (Number(hour) + 1).toString() + ':30');
          }
        }
      }

      if (hours.length > 2) {
        for (var h = hours[2]; h < hours[3]; h++) {
          if (limit !== h) {
            if (moment().hour() == h && moment().minutes() > 29 && today) {
              items.push(h + ':30 - ' + (Number(h) + 1).toString() + ':00');
            } else {
              items.push(h + ':30 - ' + (Number(h) + 1).toString() + ':00');
              items.push((Number(h) + 1).toString() + ':00 - ' + (Number(h) + 1).toString() + ':30');
            }
          }

        }
      }

      if (selectWrapper.querySelector('select')) {
        selectWrapper.querySelector('select').remove();
      }

      var select = document.createElement("select");

      for (var id in items) {
        select.options[select.options.length] = new Option(items[id]);
      }

      selectWrapper.append(select);
    }

    input.onchange = () => {
      var selection = window.schedule[moment(input.value, 'DD-MM-YYYY').format('dddd')];
      var range = [];
      var lastHour = selection[Object.keys(selection).length - 1].split(':')[0];
      var currentHour = moment().hour();
      var today = false;
      
      if (moment(input.value, 'DD-MM-YYYY').format('dddd') == moment().format('dddd')) {
        today = true;
      }

      for (const prop in selection) {
        if (selection.hasOwnProperty(prop)) {
          var hour = Number(selection[prop].split(':')[0]);

          if(today) {
            if (hour > currentHour) {
              range.push(hour);

              console.log(hour, currentHour);
            } else {
              range.push(currentHour);
              console.log(hour, currentHour);
            }
          } else {
            range.push(hour);
          }
        }
      }

      setHoursRange(range, lastHour, today);

      var hourSelected = selectWrapper.querySelector('select');

      document.querySelector('#info_extra').value = 'Hora escogida: ' + input.value + ' ' + hourSelected.value;

      hourSelected.onchange = () =>  {
        document.querySelector('#info_extra').value = 'Hora escogida: ' + input.value + ' ' + hourSelected.value;
      }
      
    }

    // picker;

    
    var cards = document.querySelectorAll('.popup--extras .shop__item--card');

    if (cards.length > 0) {

      cards.forEach(card => {
        var quantity = card.querySelector('.quantity .qty');
        var minus = card.querySelector('.qty--minus');
        var plus = card.querySelector('.qty--plus');
        var btn = card.querySelector('.add-product');
        var product_id = btn.getAttribute('data-id');
        var xhr = new XMLHttpRequest();
        var formData = new FormData();

        plus.addEventListener('click', function () {
          var oldValue = quantity.value;
          var newVal = parseFloat(oldValue) + 1;

          quantity.value = newVal;

        })

        minus.addEventListener('click', function () {
          var oldValue = quantity.value;
          var newVal;

          if (oldValue > 0) {
            newVal = parseFloat(oldValue) - 1;
          } else {
            newVal = 0;
          }
          quantity.value = newVal;

        })

        btn.addEventListener('click', function () {
          formData.append("action", 'woocommerce_ajax_add_to_cart');
          formData.append("product_id", product_id);
          formData.append("product_sku", '');
          formData.append("quantity", quantity.value);
          formData.append("order_item_status", "nuevo_pedido");
          xhr.open("POST", ajaxurl);
          xhr.send(formData);

          cards.forEach(card => {
            card.classList.toggle('loading');
          });

          xhr.onloadend = () => {
            if (xhr.status == 200) {
              cards.forEach(card => {
                card.classList.toggle('loading');
              });
              var event = new Event('update_checkout');  // (*)
              document.querySelector('body').dispatchEvent(event);
            }
          }
        })


      });
    }

    var donation = document.querySelector('.donation__wrapper');

    if(donation) {
      var qty = donation.querySelector('.quantity .qty');
      var _minus = donation.querySelector('.qty--minus');
      var _plus = donation.querySelector('.qty--plus');
      var btn = donation.querySelector('.add-product');
      var pID = btn.getAttribute('data-id');
      var ajaxCall = new XMLHttpRequest();
      var fData = new FormData();

      _plus.addEventListener('click', function () {
        var oldValue = qty.value;
        var newVal = parseFloat(oldValue) + 1;

        qty.value = newVal;

      })

      _minus.addEventListener('click', function () {
        var oldValue = qty.value;
        var newVal;

        if (oldValue > 0) {
          newVal = parseFloat(oldValue) - 1;
        } else {
          newVal = 0;
        }
        qty.value = newVal;

      })

      btn.addEventListener('click', function (e) {
        fData.append("action", 'woocommerce_ajax_add_to_cart');
        fData.append("product_id", pID);
        fData.append("product_sku", '');
        fData.append("quantity", qty.value);
        fData.append("order_item_status", "nuevo_pedido");
        ajaxCall.open("POST", ajaxurl);
        ajaxCall.send(fData);

        e.stopPropagation();
        e.preventDefault();
        
        ajaxCall.onloadend = () => {
          if (ajaxCall.status == 200) {
            var event = new Event('update_checkout');  // (*)
            document.querySelector('body').dispatchEvent(event);
          }
        }
      })
    }

    window.onload = () => {
      document.querySelector('.popup--extras').classList.add('opened');
      
    }
    
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/woocommerce-checkout.js